import hipRoof_one from "@/assets/hip_roof_one.jpg";
import gableRoof from "@/assets/gable.jpg";
import pyramid_hip_roof_one from "@/assets/pyramid_hip_roof_one.jpg";
import concrete_slab from "@/assets/concrete_slab.jpg";
import flatRoofX from "@/assets/flatroof.jpg";
import porchImage from "@/assets/porch_veranda_roof.jpg";
import roofScrews from "@/assets/roofScrews.jpg";
import textFieldComponent from "@/components/formBuilder/addons/TextAreaField.vue";
import addonFieldComponent from "@/components/formBuilder/addons/AddonCheckBoxField.vue";
export const schema = {
  roof_section_description_2: {
    step: 1,
    fieldType: "section_desc_field",
    description: `
		<div class="sectionX-title">Roof</div>
    <p>How resilient is your roof? The checklist in this section includes seven (7) resiliency features that are important to making a roof more resilient to hurricane-force winds. Examine your roof and only check boxes where your roof matches the resiliency feature described. This, together with the condition of your roof, will determine the calculation of your expected impact level.</p>
		`,
    wrapperStyle: {},
    fieldStyle: {},
    expandable: false,
    validations: {},
  },
  roof_section_video: {
    step: 1,
    fieldType: "youtube",
    videoId: "hgfbyPmTgGE",
    title: "Features of a Hurricane-Resilient Roof",
    wrapperStyle: {},
    fieldStyle: {},
    validations: {},
    description: `
    Tip! Make your assessment easier! Before you begin, watch this illustrated video. Jamal Francis, President of the Institute of Architects of Saint Lucia, explains how to assess the seven (7) resiliency features which are based in the OECS Building Guidelines, 2019.
    `,
  },
  /* 	roof_section_head: {
    step: 1,
    fieldType: "label_field",
    label: 'Roofing',
    type: "section-head",
    wrapperStyle: {},
    fieldStyle: {},
    validations: {}
  }, */
  /* 	roof_section_description: {
    step: 1,
    fieldType: "label_field",
    label: '',
    type: "desc",
    wrapperStyle: {},
    fieldStyle: {
      class:['main-question', 'boxed-content z-depth-1']
    },
    validations: {}
  }, */
  roof_section_label: {
    step: 1,
    fieldType: "label_field",
    label: `1. Roof Type`,
    type: "desc",
    helperVideo: {
      helperId: 'V10001',
      tooltip: 'Roof Type helper video'
    },
    wrapperStyle: {},
    badge: "Core resiliency feature",
    fieldStyle: {
      class: ["section-title", "core-ref", "section-lead"],
    },
    validations: {},
  },
  roof_type: {
    step: 1,
    fieldType: "custom_field",
    label: "" /* "Roof is one of the following types:" */,
    questionNum: 1,
    titleText: "Roof is one or a combination of the following types:",
    placeholder: "",
    helperText: "",
    value: "",
    rFeature: "roof",
    list_type: "ol",
    section: "roof",
    additionalKey: "roof_type_other_resilient",
    list: [
      {
        displayText: /* html */ `<a href="#" class="list-label" helper-id="F701">Hip roof</a>`,
        more_detail: /* html */ `<div class="grey lighten-4 list-note"><b>Note: </b> <br>Do not select if you have a low-pitched hip roof (with slopes less than 25 degrees) as these are not as resilient.</div>
					<div class="flex-rows">

							<div class="flex-columns">
								<div class="card hoverable">
									<div class="card-content">
									  <img width="100%" class="materialboxed" data-caption="Hip Roof" src="${hipRoof_one}">
									</div>
									<div class="card-custom-title">Hip Roof</div>
								</div>
							</div>

              <div class="flex-columns">
              <div class="card hoverable">
                <div class="card-content">
                  <img width="100%" class="materialboxed" data-caption="Hip Roof" src="${pyramid_hip_roof_one}">
                </div>
                <div class="card-custom-title">Pyramid Hip Roof</div>
              </div>
            </div>
							<div class="flex-columns">
								<div class="card hoverable">
									<div class="card-content">
										<img width="100%" class="materialboxed" data-caption="Damaged Low-Pitched Hip Roof" src="https://i2.wp.com/api.sldb.lc/wp-content/uploads/2021/02/Damaged-Low-Pitched-Hip-Roof.jpg?fit=960%2C720&ssl=1">
									</div>
									<div class="card-custom-title"> Damaged Low-Pitched Hip Roof</div>
								</div>
							</div>
					</div>`,
      },
      {
        displayText: `<span class="list-label"> Concrete slab roof </span>`,
        more_detail: `
        <div class="flex-rows">
						<div class="flex-columns">
							<div class="card hoverable">
							<div class="card-content">
								<img src="${concrete_slab}" class="materialboxed" width="100%" />
							</div>
							<div class="card-custom-title"></div>
							</div>
						</div>
            </div>
        `,
        additional: {
          fullText: "Concrete slab roof (flat, reinforced concrete roof)",
          note: "Concrete roofs should be properly engineered to ensure they are safe in the event of an earthquake.",
        },
      },
      {
        displayText: `<a href='#' class="list-label" helper-id='F339'>Strongly constructed gable roof</a>`,
        more_detail: /* html */ `
					<div class="grey lighten-4 list-note"><b>Note: </b> <br>
					 Gable roofs (roofs with two sloping slides) typically do not withstand hurricane-force winds as well as hip roofs. Low-pitched gable roofs (with slopes less than 25 degrees) are particularly vulnerable. Only select this option, if you have a strongly constructed gable roof as shown in the illustration provided.
					</div>
					<div class="flex-rows">
						<div class="flex-columns">
							<div class="card hoverable">
							<div class="card-content">
								<img src="${gableRoof}" class="materialboxed" width="100%" />
							</div>
							<div class="card-custom-title"></div>
							</div>
						</div>

						<div class="flex-columns">
							<div class="card hoverable">
							<div class="card-content">
								<img src="${flatRoofX}" class="materialboxed" width="100%" />
							</div>
							<div class="card-custom-title"></div>
							</div>
						</div>

						<div class="flex-columns">
						<div class="card hoverable">
							<div class="card-content">
								<img width="100%" class="materialboxed" src="https://i1.wp.com/api.sldb.lc/wp-content/uploads/2021/02/Strongly-Constructed-Gable-Roof-Elevation_Side-View.jpg?fit=960%2C720&ssl=1" alt="">

							</div>
							<div class="card-custom-title"></div>
						</div>
					</div>
				</div>

					</div>
					`,
        additional: {
          fullText: `<a href='#' helper-id='F339' class="list-label">Strongly constructed gable roof</a>`,
          note: `Gable roofs (roofs with two sloping slides) typically do not withstand hurricane-force winds as well as hip roofs. Low-pitched gable roofs (with slopes less than 25 degrees) are particularly vulnerable. Only select this option, if you have a strongly constructed gable roof as shown in the illustration provided (images without an "X"). Do not select if you have a low-pitched/flat gable roof (with slopes less than 25 degrees).
						`,
        },
      },
      {
        displayText: `<span class="list-label">Other resilient roof design (provide details)</span>`,
        componentLoader: textFieldComponent,
        additional: {
          /*  */
        },
      },
    ],
    note: `
    The three (3) house roof types presented here are generally known to withstand hurricane-force winds best.
    Other roof types may be resilient, depending on their specific design and construction.
    `,
    cardStyle: {
      class: "",
      style: {
        background: "",
      },
    },
    wrapperStyle: {},

    fieldStyle: {},
    validations: {},
  },
  rafters_section_label: {
    step: 1,
    fieldType: "label_field",
    label: "2. Rafters",
    helperVideo: {
      helperId: 'V10002',
      tooltip: 'Rafters helper video'
    },
    type: "desc",
    wrapperStyle: {},
    badge: "Core resiliency feature",
    fieldStyle: {
      class: ["section-lead", "core-ref"],
    },
    validations: {},
  },
  spaced_rafters: {
    step: 1,
    fieldType: "custom_field",
    titleText:
      "<a href='#' helper-id='D193'>Rafters</a> are closely spaced (no more than 2 feet apart) and properly fixed to the <a href='#' helper-id='D638'>ring beam</a> (in the case of masonry/concrete houses) or the <a href='#' helper-id='D264'>wall plate</a> (mainly in the case of timber/wooden houses).",
    /* html */
    // description: `There are different methods/techniques for doing this, for example, securing the rafters to the ring beam by using hurricane straps/ties (in masonry/concrete structures) or using hurricane straps/ties to secure the rafters to the wall plate (in timber structures).
    //		<a href='#'  helper-style="slideshow" helper-id='F260'> See the illustrations of examples for  how to properly secure rafters </a>.`,
    note: `<p style="margin-bottom: 12px;">In many cases, you may not be able to assess if the rafters are properly fixed from a visual inspection. If you are unsure about your rafters, ask your contractor or someone else with knowledge of your home's construction whether the rafters are properly spaced and connected to the structure based on the standards above. </p>
      <p style="margin-bottom: 12px;">
      <label>
      `,
    noteComponent: {
      disableParent: true,
      text: "Check this box if you cannot get this information and make your best assessment of likely impact from other roof features and the condition of the roof.",
      componentLoader: addonFieldComponent,
    },
    additionalKey: "rafters_section_no_rafters",
    placeholder: "",
    helperText: "",
    questionNum: 2,
    value: "",
    rFeature: "roof",
    answer: ["yes"],
    options: [],
    slotContent: /* html */ `
    <div class="col s12">
        There are different methods/techniques for doing this, for example, securing the rafters to the ring beam by using hurricane straps/ties (in masonry/concrete structures) or using hurricane straps/ties to secure the rafters to the wall plate (in timber structures).
			<a href='#'  helper-style="slideshow" helper-id='F260'> See the illustrations of examples for  how to properly secure rafters.</a>
    </div>

    <div class="flex-rows">

			<div class="flex-columns">
				<div class="card hoverable">
					<div class="card-content">
					<img data-caption="Closely spaced rafters"  class="materialboxed"
					src="https://i1.wp.com/api.sldb.lc/wp-content/uploads/2021/02/Hip-Roof-Diagram-Elevation_Side-View.jpg?fit=960%2C720&ssl=1" width="100%" />
					</div>
					<div class="card-custom-title">Closely spaced rafters </div>
				</div>
			</div>

			<div class="flex-columns">
				<div class="card hoverable">
					<div class="card-content">
					<img data-caption="Closely spaced rafters"  class="materialboxed"
					src="https://api.sldb.lc/wp-content/uploads/2021/05/Closely-spaced-rafters-no-more-than-2-feet-apart-properly-fixed-to-the-ring-beam-2.jpg" width="100%" />
					</div>
					<div class="card-custom-title">Closely spaced rafters </div>
				</div>
			</div>

      <div class="flex-columns">
      <div class="card hoverable">
        <div class="card-content">
        <img data-caption="Closely spaced rafters"  class="materialboxed"
        src="https://api.sldb.lc/wp-content/uploads/2021/05/Closely-spaced-rafters-no-more-than-2-feet-apart-properly-fixed-to-the-ring-beam@2x-scaled.jpg" width="100%" />
        </div>
        <div class="card-custom-title">Closely spaced rafters </div>
      </div>
    </div>


		</div>
		`,
    section: "roof",
    preState: {
      active: true,
      object: "homeProfile",
      option: "roof_type",
      value: "Flat (Concrete slab)",
      action: "disable",
      isChecked: false,
      array: false,
      message: "Applies to non-concrete roofs only ",
    },
    // invalid: true,
    wrapperStyle: {
      // class: 'col s12'
    },
    cardStyle: {
      class: "",
      style: {
        background: "",
      },
    },
    fieldStyle: {},
    validations: {},
  },
  porch_v_section_label: {
    step: 1,
    fieldType: "label_field",
    label: "3 a. Porch/Veranda Roof Design ",
    helperVideo: {
      helperId: 'V10003',
      tooltip: ' Porch/Veranda and Garage/Carport Roof Design'
    },
    type: "desc",
    wrapperStyle: {},
    badge: "Core resiliency feature",
    fieldStyle: {
      class: ["section-lead", "core-ref"],
    },
    validations: {},
  },
  roofs_separated: {
    step: 1,
    fieldType: "custom_field",
    // fieldType: 'text',
    label: "porch/veranda separated from main roof",
    titleText: /* html */ ` One of the following is true: `,
    questionNum: 3,
    placeholder: "",
    helperText: "",
    preState: {
      active: true,
      object: "homeProfile",
      option: "porches_verandas_select",
      value: "none",
      values: ["none", "no-roof"],
      action: "disable",
      isChecked: false,
      array: false,
      message: "Only for Porches/verandas",
    },
    value: "",
    rFeature: "roof",
    answer: ["yes"],
    options: [],
    section: "roof",
    slotContent: /* html */ `

    <ol class="is-roman">
      <li>
      All porch/veranda roofs are separate from the main house roof and can break away in high winds, if damaged, without affecting the main house roof.
        <div class="flex-rows">

          <div class="flex-columns">
            <div class="card hoverable">
              <div class="card-content">
                <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/non_concrete_porch_veranda_roof_detached.jpg">
                <div class="card-custom-title"></div>
              </div>
            </div>
          </div>


        <div class="flex-columns">
          <div class="card hoverable">
            <div class="card-content">
              <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/Non-concrete-porch_veranda-roof-detached-from-main-house-roof_2.jpg">
              <div class="card-custom-title"></div>
            </div>
          </div>
        </div>

        </div>
      </li>
      <li>
        Porch/veranda roofs are concrete.
        <div class="flex-rows">
          <div class="flex-columns">
            <div class="card hoverable">
              <div class="card-content">
                <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/concrete_porch_veranda_roof_detached.jpg">
                <div class="card-custom-title"></div>
              </div>
            </div>
          </div>
          <div class="flex-columns">
            <div class="card hoverable">
              <div class="card-content">
                <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/concrete_porch_veranda_roof_attached.jpg">
                <div class="card-custom-title"></div>
              </div>
            </div>

        </div>
        </div>
      </li>


      <li>Porch/veranda roof structures that are attached to the main roof are properly secured to ensure the stability of the entire roof structure, including the main roof. There are different options for doing this. For example, an integrated roof design with all of the following features present is acceptable:
        <ul class="browser-default">
         <li>
         the rafters of the main roof that extend over the porch/veranda are supported by a porch/veranda ring beam (concrete or wooden), AND
         </li>
         <li>
          the porch/veranda ring beam is structurally connected to the main house, AND
         </li>
         <li>
         the porch/veranda ring beam is structurally supported by strong porch/veranda columns or posts.
         </li>
        </ul>


<div class="flex-rows">
  <div class="flex-columns">

        <div class="card hoverable">

            <div class="card-content">
              <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/structural_connections_non_concrete_porch_veranda.jpg">
              <div class="card-custom-title"></div>
              </div>

          </div>

        </div>
   </div>


      </li>
    </ol>
			`,
    wrapperStyle: {},
    cardStyle: {
      class: "",
      style: {
        background: "",
      },
    },
    fieldStyle: {},
    validations: {},
  },
  garage_v_section_label: {
    step: 1,
    fieldType: "label_field",
    label: "3 b. Garage/Carport Roof Design ",
    type: "desc",
    wrapperStyle: {},
    badge: "Core resiliency feature",
    fieldStyle: {
      class: ["section-lead", "core-ref"],
    },
    validations: {},
  },
  garage_separated: {
    step: 1,
    fieldType: "custom_field",
    // fieldType: 'text',
    label: "Garage/Carport Roof Design ",
    titleText: /* html */ ` One of the following is true: `,
    questionNum: 3,
    placeholder: "",
    preState: {
      active: true,
      object: "homeProfile",
      option: "garage_carport_select",
      value: "none",
      action: "disable",
      isChecked: false,
      array: false,
      message: "Only for Garage/Carport roof designs",
    },
    helperText: "",
    value: "",
    rFeature: "roof",
    answer: ["yes"],
    options: [],
    section: "roof",
    slotContent: /* html */ `

    <ol class="is-roman">
      <li>
      The garage or carport has a roof that is independent of the main house roof and can break away in high winds, if damaged, without affecting the main house roof.
        <div class="flex-rows">

          <div class="flex-columns">
            <div class="card hoverable">
              <div class="card-content">
                <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/open_sided_and_attached_to_main_house_with_independent_roof.jpg">
                <div class="card-custom-title"></div>
              </div>
            </div>
          </div>

        <div class="flex-columns">
          <div class="card hoverable">
            <div class="card-content">
              <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/fully_enclosed_and_detached_from_main_house_with_independent_roof.jpg">
              <div class="card-custom-title"></div>
            </div>
          </div>
        </div>

        <div class="flex-columns">
          <div class="card hoverable">
            <div class="card-content">
              <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/fully_enclosed_and_attached_to_main_house_with_independent_roof.jpg">
              <div class="card-custom-title"></div>
            </div>
          </div>
        </div>

        <div class="flex-columns">
        <div class="card hoverable">
          <div class="card-content">
            <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/open_sided_and_detached_from_main_house_with_independent_roof.jpg">
            <div class="card-custom-title"></div>
          </div>
        </div>
      </div>


        </div>
      </li>
      <li>
			The Garage/carport roof is concrete.
        <div class="flex-rows">

        <div class="flex-columns">
          <div class="card hoverable">
            <div class="card-content">
              <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/open_sided_and_attached_to_main_house_with_connected_concrete_roof_system.jpg">
              <div class="card-custom-title"></div>
            </div>
          </div>
        </div>

        </div>
      </li>

      <li>
			Garages with roofs that are integrated into the main house roof are fully enclosed garages and the garage roof is properly fastened to a ring beam or wall plate to ensure the stability of the entire roof structure, including the main roof.
        <div class="flex-rows">

        <div class="flex-columns">
          <div class="card hoverable">
            <div class="card-content">
              <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/fully_enclosed_and_attached_to_main_house_with_connected_roof_system.jpg">
              <div class="card-custom-title"></div>
            </div>
          </div>
        </div>

        </div>
      </li>

      <li>
      Open-sided carport roof structures that are attached to the main roof are properly secured to ensure the stability of the entire roof structure, including the main roof. For example, an integrated roof design with all of the following features present is acceptable:
      <ul class="browser-default">
       <li>
       the rafters of the main roof that extend over the carport are supported by a carport ring beam (concrete or wooden), AND
       </li>
       <li>
       the carport ring beam is structurally connected to the main house, AND
       </li>
       <li>	the carport ring beam is structurally supported by strong columns or posts.
       </li>
      </ul>
      <div class="flex-rows">

      <div class="flex-columns">
        <div class="card hoverable">
          <div class="card-content">
            <img class="materialboxed"  src="https://api.sldb.lc/wp-content/uploads/2021/05/Integated-garage-roof-with-ring-beam-structurally-connected-to-main-house-view-2.jpg">
            <div class="card-custom-title"></div>
          </div>
        </div>
      </div>



      <div class="flex-columns">
      <div class="card hoverable">
      <div class="card-content">
        <img class="materialboxed" src="https://api.sldb.lc/wp-content/uploads/2021/05/Integated-garage-roof-with-ring-beam-structurally-connected-to-main-house-view-3-with-structural-members.jpg">
        <div class="card-custom-title"></div>
      </div>
    </div>
    </div>
      </div>
    </li>




    </ol>
			`,
    wrapperStyle: {},
    cardStyle: {
      class: "",
      style: {
        background: "",
      },
    },
    fieldStyle: {},
    validations: {},
  },
  roof_overhangs_section_label: {
    step: 1,
    fieldType: "label_field",
    label: "4. Roof Overhangs",
    type: "desc",
    helperVideo: {
      helperId: 'V10004',
      tooltip: 'Roof Overhang helper video'
    },
    wrapperStyle: {},
    badge: "Core resiliency feature",
    fieldStyle: {
      class: ["section-lead", "core-ref"],
    },
    validations: {},
  },
  roof_overhangs: {
    step: 1,
    fieldType: "custom_field",
    questionNum: 4,

    titleText: `Roof overhangs are not more than 18 inches at the eaves (that is, the horizontal distance between the exterior wall and the edge of the roof overhang is 18 inches or less).`,
    label: "Roof Overhangs",
    placeholder: "",
    helperText: "",
    value: "",
    rFeature: "roof",
    answer: ["yes"],
    options: [],
    preState: {
      active: true,
      object: "homeProfile",
      option: "roof_type",
      value: "Flat (Concrete slab)",
      action: "disable",
      isChecked: false,
      array: false,
      message: "Applies to non-concrete roofs only ",
    },
    section: "roof",
    cardStyle: {
      class: "",
      style: {
        background: "",
      },
    },
    slotContent: /* html */ `
    <div class="flex-rows">

<div class="flex-columns">
    <div class="card hoverable">
        <div class="card-content">
        <img data-caption="Closely spaced rafters"  class="materialboxed"
        src="https://api.sldb.lc/wp-content/uploads/2021/05/Roof-overhang.jpg" width="100%" />
        </div>
        <div class="card-custom-title">Roof overhang</div>
    </div>
</div>
</div>
    `,
    fieldStyle: {},
    validations: {},
  },
  roof_covering_section_label: {
    step: 1,
    fieldType: "label_field",
    label: "5. Roof Covering Installation",
    helperVideo: {
      helperId: 'V10005',
      tooltip: 'Roof Covering Installation helper video'
    },
    type: "desc",
    wrapperStyle: {},
    /* badge:'Core resiliency feature', */
    fieldStyle: {
      class: ["section-lead", ""],
    },
    validations: {},
  },
  roof_covering: {
    step: 1,
    fieldType: "custom_field",
    questionNum: 5,

    titleText: /* html */ `
			Roof covering is properly installed/fixed to the <a href='#' helper-id='D687'>roof sheathing.</a> <br>
			`,
    placeholder: "",
    slotContent: /* html */ `
			<ul class="browser-default">
			<li>For galvanized/galvalume sheets, check the box only if sheets are screwed in (not nailed in). <a href='#' helper-id='F101'>See how to properly install screws.</a></li>
			<li>For shingles/tiles, check the box only if installation/fixing mechanism is according to factory required specifications, including using any specified adhesives.</li>
			</ul>

			<div class="flex-rows">
			<div class="flex-columns">
			<div class="card hoverable">
				<div class="card-content">
					<img class="materialboxed" src="${roofScrews}">
				</div>
			</div>
			</div>
	</div>
			`,
    helperText: "",
    value: "",
    rFeature: "roof",
    preState: {
      active: true,
      object: "homeProfile",
      option: "roof_type",
      value: "Flat (Concrete slab)",
      action: "disable",
      isChecked: false,
      array: false,
      message: "Applies to non-concrete roofs only ",
    },
    answer: ["yes"],
    options: [],
    section: "roof",
    // invalid: true,
    wrapperStyle: {},
    cardStyle: {
      class: "",
      style: {
        background: "",
      },
    },
    fieldStyle: {},
    validations: {},
  },
  roof_screws_section_label: {
    step: 1,
    fieldType: "label_field",
    label: "6. Roof Fastener Spacing",
    helperVideo: {
      helperId: 'V10006',
      tooltip: 'Roof Fastener Spacing helper video'
    },
    type: "desc",
    wrapperStyle: {},
    /* badge:'Core resiliency feature', */
    fieldStyle: {
      class: ["section-lead", ""],
    },
    validations: {},
  },
  roof_fasteners: {
    step: 1,
    fieldType: "custom_field",
    questionNum: 6,
    // fieldType: 'text',
    preState: {
      active: true,
      object: "homeProfile",
      option: "roof_type",
      value: "Flat (Concrete slab)",
      action: "disable",
      isChecked: false,
      array: false,
      message: "Applies to non-concrete roofs only ",
    },
    titleText: /* html */ `
			Roof fasteners are installed at regular intervals/spacings in roof covering in accordance with the <a href='#' helper-id='F251'> recommended standard</a> for the covering used. Inadequate fasteners in the roof covering can lead to loss of the roof covering.
			`,
    // description: /* html */ `
    //		<ul class='browser-default'>
    //		  <li>For galvanized / galvalume sheets, check the box only if sheets are screwed in using the <a href='#' helper-id='F251'> recommended standard</a>, including additional screws at the roof edges and ridge where there is additional strain in hurricane conditions.</li>
    //			<li>For shingles / tiles, check the box only if fastener spacing is according to factory required specifications. </li>
    //		</ul>
    //		`,
    placeholder: "",

    slotContent: /* html */ `
    <ul class='browser-default'>
			  <li>For galvanized/galvalume sheets, check the box only if sheets are screwed in using the <a href='#' helper-id='F251'> recommended standard</a>, including additional screws at the roof edges and ridge where there is additional strain in hurricane conditions.</li>
				<li>For shingles/tiles, check the box only if fastener spacing is according to factory required specifications. </li>
			</ul>

    <div class="flex-rows">
			<div class="flex-columns">
			<div class="card hoverable">
				<div class="card-content">
					<img class="materialboxed" src="https://api.sldb.lc/wp-content/uploads/2021/02/Roof-Fastener-Spacing.jpg">
				</div>
			</div>
			</div>
	</div>
			`,
    helperText: "",
    value: "",
    rFeature: "roof",
    answer: ["yes"],
    options: [],
    section: "roof",
    // invalid: true,
    wrapperStyle: {},
    cardStyle: {
      class: "",
      style: {
        background: "",
      },
    },
    fieldStyle: {},
    validations: {},
  },
  roof_covering_thickness_label: {
    step: 1,
    fieldType: "label_field",
    label: "7. Roof Covering Thickness and Overlap",
    helperVideo: {
      helperId: 'V10007',
      tooltip: 'Roof Covering Thickness helper video'
    },
    type: "desc",
    wrapperStyle: {},
    /* badge:'Core resiliency feature', */
    fieldStyle: {
      class: ["section-lead", ""],
    },
    validations: {},
  },
  roof_covering_thickness: {
    step: 1,
    fieldType: "custom_field",
    questionNum: 7,
    preState: {
      active: true,
      object: "homeProfile",
      option: "roof_type",
      value: "Flat (Concrete slab)",
      action: "disable",
      isChecked: false,
      array: false,
      message: "Applies to non-concrete roofs only ",
    },
    // fieldType: 'text',
    titleText: `Roof covering has the appropriate thickness and degree of overlap.`,
    //description:
    //  "Where asphalt shingles are used, they should be fixed using the specified adhesives in accordance with the manufacturer's instructions.",
    slotContent: `
			<ul class="browser-default">
			<li>For galvanized/galvalume sheets, check the box only if sheets are no thinner than 26 gauge (24 gauge is the recommended thickness) and overlap the neighbouring sheet by at least 2.5 <a href='#' helper-id='D86'>corrugations</a>   (ridges or grooves in the sheet). </li>
			<li>For shingles/tiles, check the box only if the shingles/tiles are made from a heavy material such as concrete, metal or clay and overlap according to manufacturer's specifications.</li>
			</ul>`,
    note: "The gauge of a galvanized sheet is a measure of its thickness or thinness - the lower the gauge number, the thicker the sheet.",
    placeholder: "",
    helperText: "",
    value: "",
    rFeature: "roof",
    answer: ["yes"],
    options: [],
    section: "roof",
    // invalid: true,
    wrapperStyle: {},
    cardStyle: {
      class: "",
      style: {
        background: "",
      },
    },
    fieldStyle: {},
    validations: {},
  },

  roof_features: {
    step: 1,
    fieldType: "features_field",
    validations: {},
  },

  roof_condition: {
    step: 1,
    fieldType: "custom_group_radio_field",
    questionNum: 8,
    titleText: `Roof Condition`,
    helperVideo: {
      helperId: 'V10008',
      tooltip: 'Roof Condition helper video'
    },
    label: "How would you describe the general condition of your roof? ",
    placeholder: "",
    helperText: "",
    showQuestionNum: false,
    section: "roof",
    value: "",
    description: /* html */ `
    <ul class="criteria-list">
      <li><b>Good:</b> No structural repairs required.</li>
      <li><b>Fair:</b> Minor structural repairs are required. Examples: a small percentage of missing or rusted screws; a small percentage of rusted or damaged roof sheets/shingles; a small percentage of roof structure (e.g., rafters or roof sheathing) is rotted or termite-infested </li>
      <li><b>Poor:</b> Major structural repairs/replacement is required. Examples: a large percentage of missing or rusted screws; a large percentage of rusted or damaged roof sheets/shingles; a large percentage of roof structure (e.g., rafters or roof sheathing) is rotted or termite-infested</li>
    </ul>
    `,
    //expandList: [
    /* 	"Excellent - No structural repairs or cosmetic work required", */
    //  "Good - No structural repairs required.",
    //  "Fair - Minor structural repairs required (e.g. replacement of a few damaged roof sheets/shingles).",
    //  "Poor - Major structural repairs/replacement required (e.g. major cracks or breaks, rotting, termite infestation or rusting present). . ",
    //],
    answer: "isCondition",
    options: [
      /* 			{
							text: 'Excellent',
							value: 'excellent'
					}, */ {
        text: "Good",
        value: "good",
      },
      {
        text: "Fair",
        value: "fair",
      },
      {
        text: "Poor",
        value: "poor",
      },
    ],
    wrapperStyle: {
      class: "grey lighten-3 negative-margins", //'col s12'
    },
    gridStyle: {
      grid: "col s6",
    },
    fieldStyle: {},
    validations: {},
  },
  roof_fair_poor_issue: {
    step: 1,
    target: "roof_condition",
    dataConditions: ["fair", "poor"],
    fieldType: "condition_field",
    wrapperStyle: {
      class: "grey lighten-3 negative-margins",
    },
    section: "roof",
    value: "",
    label: "If you selected 'fair' or 'poor,' briefly describe the issues.",
    validations: {},
  },
  section_one_complete: {
    step: 1,
    fieldType: "complete_field",
    sectionName: "",
    validations: {},
  },

  /*   windows_doors_section_head: {
    step: 2,
    fieldType: "label_field",
    label: "Windows and Doors",
    type: "section-head",
    wrapperStyle: {
      class: "section-head",
      style: {},
    },
    fieldStyle: {},
    validations: {},
  }, */
  windows_doors_section_head: {
    step: 2,
    fieldType: "section_desc_field",
    description: `
			<div class="sectionX-title">Windows and Doors</div>
			`,
    wrapperStyle: {},
    fieldStyle: {},
    validations: {},
  },
  windows_doors_section_head_two: {
    step: 2,
    showIcon: false,
    fieldType: "section_desc_field",
    description: `
			<p>Are your windows resilient?  Check the box if your windows meet/match the description of the resiliency feature.  Check all resiliency features that are present.</p>`,
    wrapperStyle: {},
    fieldStyle: {},
    validations: {},
  },
  window_installation_section_label: {
    step: 2,
    fieldType: "label_field",
    label: "1. Window Installation",
    type: "desc",
    wrapperStyle: {},
    badge: "Core resiliency feature",
    fieldStyle: {
      class: ["section-title", "core-ref", "section-lead"],
    },
    validations: {},
  },

  windows_installation: {
    step: 2,
    fieldType: "custom_group_checkbox_field",
    questionNum: 9,
    showQuestionNum: false,
    label: ` Windows are properly installed (as per manufacturer’s specifications).`,
    placeholder: "",
    helperText: "",
    value: false,
    section: "window",
    groupTag: "window",
    rFeature: "window",
    answer: ["yes"],
    description: `
    Proper window installation includes, but is not limited to the following (all must be present):`,
    options: [
      {
        text: `window opening includes a reinforced concrete or steel <a href="#" helper-id="D969" >lintel</a> (in the case of masonry or concrete walls) or a timber lintel (in the case of timber wall installations);`,
        value: "window_opening_includes_a_reinforced_concrete_or_steel",
      },
      {
        text: `the use of <a href="#" helper-id="D1001">concrete screws</a> or other suitable masonry fasteners (bolts, anchors, nails) along the <a href="#" helper-id="D1003">window frame</a> to secure the window frame to the perimeter of the window opening for concrete or masonry walls;`,
        value: "suitable_masonry_anchors_fasteners",
      },
      {
        text: `the use of suitable <a href="#" helper-id="D1009">wood screws</a> or fasteners (bolts, anchors, nails) along the window frame to secure the window frame to the perimeter of the window opening for timber-framed walls; and`,
        value: `suitable_wood_screws_or_fasteners`,
      },
      {
        text: "the use of suitable waterproof sealant (e.g. silicone) along the joints between the window frame and the perimeter of the window opening.",
        value: "suitable_waterproof_sealant",
      },
    ],
    gridStyle: {
      grid: "col s12",
    },
    cardStyle: {
      class: "",
      style: {},
    },
    // invalid: true,
    wrapperStyle: {
      class: "",
    },
    fieldStyle: {},
    validations: {},
  },
  window_type_features_label: {
    step: 2,
    fieldType: "label_field",
    label: "2.  Window Type ",
    type: "desc",
    wrapperStyle: {},
    //badge: "Core resiliency feature",
    fieldStyle: {
      class: ["section-title", "section-lead"],
    },
    validations: {},
  },

  window_type_features: {
    step: 2,
    fieldType: "custom_group_checkbox_field",
    showQuestionNum: false,
    questionNum: 10,
    label: `
			One or a combination of the following are present for all windows:  `,
    placeholder: "",
    helperText: "",
    value: false,
    section: "window",
    groupTag: "window",
    rFeature: "window",
    options: [
      {
        text: `<a href="#" helper-id="D858">Impact-resistant glass windows</a> which have the <a href="#"
					helper-id="D934">Miami Dade Notice of Acceptance</a> or equivalent standard.
					(Windows should have come with a removable label when purchased).`,
        value: `impact_resistant`,
      },
      {
        text: 'Solid metal windows  - e.g. <a href="#" helper-id="D843">aluminium louvers</a>',
        value: "aluminum_louvers",
      },
      {
        text: 'Solid wooden windows  - e.g. <a href="#" helper-id="D618">solid wooden casements</a>',
        value: "solid_wooden_shutters",
      },
      {
        text: `Windows with hurricane shutters which have the <a href="#"	helper-id="D934">Miami Dade Notice of Acceptance</a> or equivalent standard`,
        value: "hurricane_shutters",
      },
    ],
    wrapperStyle: {
      class: "",
    },
    gridStyle: {
      grid: "col s12",
    },
    fieldStyle: {},
    validations: {},
  },

  window_only_condition: {
    step: 2,
    fieldType: "custom_group_radio_field",
    questionNum: 12,
    showQuestionNum: false,
    titleText: `Window Condition`,
    label: "What is the general condition of your windows?",
    placeholder: "",
    helperText: "",
    value: "",
    section: "window",
    answer: "isCondition",
    options: [
      {
        text: "Good",
        value: "good",
      },
      {
        text: "Fair",
        value: "fair",
      },
      {
        text: "Poor",
        value: "poor",
      },
    ],
    description: /* html */ `
    <ul class="criteria-list">
    <li><b>Good:</b> No structural repairs are required.</li>
    <li><b>Fair:</b> Minor structural repairs are required. Examples: loose glass panes; sealant deteriorated; some rusting present</li>
    <li><b>Poor:</b> Major structural repairs/replacement is required. Examples: window unable to close properly; hinge or locking mechanism needs repair/replacement; broken or missing glass; cracks, rotting, termite infestation or significant rusting present</li>
    </ul>
    `,
    /*   expandList: [
      "Good - No structural repairs required.",
      "Fair Minor structural repairs required (e.g. hinge or handle needing repair/replacement)",
      "Poor - Major structural repairs/replacement required (e.g. cracks or breaks, rotting, termite infestation or rusting present).",
    ], */
    wrapperStyle: {
      class: "grey lighten-3 negative-margins-no-top",
    },
    gridStyle: {
      grid: "col s6",
    },
    fieldStyle: {},
    validations: {},
  },

  window_fair_poor_issue: {
    step: 2,
    target: "window_only_condition",
    dataConditions: ["fair", "poor"],
    fieldType: "condition_field",
    wrapperStyle: {
      class: "grey lighten-3 negative-margins",
    },
    section: "window",
    value: "",
    label: "If you selected 'fair' or 'poor,' briefly describe the issues.",
    validations: {},
  },
  doors_only_section_head: {
    step: 2,
    fieldType: "section_desc_field",
    description: `Are your exterior doors resilient? Check the box if your doors meet/match the description of the resiliency feature. Check all resiliency features that are present.`,
    wrapperStyle: {},
    fieldStyle: {},
    showIcon: false,
    validations: {},
  },
  /*   windows_doors_section_description: {
    step: 2,
    fieldType: "label_field",
    label: `Are your windows and exterior doors resilient? Check all boxes where your windows or doors match the resiliency feature described.`,
    type: "desc",
    wrapperStyle: {
      class: "",
    },
    fieldStyle: {
      class: "main-question",
    },
    validations: {},
  }, */
  door_installation_section_label: {
    step: 2,
    fieldType: "label_field",
    label: "3. Door Installation",
    type: "desc",
    wrapperStyle: {},
    badge: "Core resiliency feature",
    fieldStyle: {
      class: ["section-title", "core-ref", "section-lead"],
    },
    validations: {},
  },

  door_installation_resiliency_features: {
    step: 2,
    fieldType: "custom_group_checkbox_field",
    questionNum: 11,
    showQuestionNum: false,
    label: `Doors are properly installed.
 `,
    placeholder: "",
    helperText: "",
    value: false,
    groupTag: "door",
    rFeature: "door",
    section: "window",
    description: `  Proper door installation includes but is not limited to the following (all must be present):`,
    options: [
      {
        text:
          'door opening includes a reinforced concrete or steel <a href="#" helper-id="D969">lintel</a> (in the case of masonry or concrete walls) or a timber lintel (in the case of timber-framed wall installations);',
        value: "reinforced_concrete_or_steel_lintel",
      },
      {
        text: `the use of <a href="#" helper-id="D1001">concrete screws</a> or other suitable masonry anchors/fasteners along the <a href="#" helper-id="D1006"> doorframe</a>, to secure the doorframe to the perimeter of the door opening, for concrete or masonry walls;`,
        value: "concrete_screws_or_other_suitable_masonry_anchors_fasteners;",
      },
      {
        text: `the use of suitable <a href="#" helper-id="D1009">wood screws</a> or fasteners along the doorframe, to secure the doorframe to the door opening, for timber-framed walls; and`,
        value: " wood_screws_or_fasteners_along_the_doorframe",
      },
      {
        text: `the of use of suitable waterproof <a href="#" helper-id="D1010">sealant</a> (e.g. silicone) along the joints between the doorframe and perimeter of the door opening with the exception of the base of the door.`,
        value: "waterproof_sealant_silicone",
      },
    ],
    wrapperStyle: {
      class: "",
    },
    gridStyle: {
      grid: "col s12",
    },
    fieldStyle: {},
    validations: {},
  },
  door_type_section_label: {
    step: 2,
    fieldType: "label_field",
    label: "4. Door Type",
    type: "desc",
    wrapperStyle: {},

    fieldStyle: {
      class: ["section-title", "section-lead"],
    },
    validations: {},
  },

  door_resiliency_features: {
    step: 2,
    fieldType: "custom_group_checkbox_field",
    questionNum: 11,
    showQuestionNum: false,
    label: `One or a combination of the following are present for all doors:
 `,
    placeholder: "",
    helperText: "",
    value: false,
    groupTag: "door",
    rFeature: "door",
    section: "window",
    options: [
      {
        text:
          'Impact-resistant glass doors which have the <a href="#" helper-id="D934">Miami Dade Notice of Acceptance</a> or equivalent standard. (Doors should have come with a removable label when purchased).',
        value: "impact_resistant_glass_doors_which_have_a_miami_dade_notice",
      },
      {
        text: "Solid wood, metal or UPVC doors",
        value: "solid_wood_metal_or_upvc_doors",
      },
      {
        text: "Solid wood, metal or UPVC doors with impact-resistant glass",
        value: " solid_wood_metal_or_upvc_doors_impact_resistant_glass",
      },
      {
        text: 'Storm/hurricane shutters for exterior doors - shutters should have the  <a href="#" helper-id="D934">Miami Dade Notice of Acceptance</a> or equivalent standard',
        value: "doors_with_storm_hurricane_shutters_which_have_a_Miami_Dade_Notice_of_acceptance",
      },
    ],
    wrapperStyle: {
      class: "",
    },
    gridStyle: {
      grid: "col s12",
    },
    fieldStyle: {},
    validations: {},
  },
  door_condition: {
    step: 2,
    fieldType: "custom_group_radio_field",
    questionNum: 13,
    showQuestionNum: false,
    titleText: `Door Condition`,
    label: "What is the general condition of your exterior doors?",
    placeholder: "",
    helperText: "",
    value: "",
    section: "window",
    answer: "isCondition",
    options: [
      {
        text: "Good",
        value: "good",
      },
      {
        text: "Fair",
        value: "fair",
      },
      {
        text: "Poor",
        value: "poor",
      },
    ],
    description: `
    <ul class="criteria-list">
    <li><b>Good:</b> No structural repairs are required. </li>
    <li><b>Fair:</b> Minor structural repairs are required. Examples: loose glass panes; sealant deteriorated; some rusting present</li>
    <li><b>Poor:</b> Major structural repairs/replacement is required. Examples: door unable to close properly; hinge or locking mechanism needs repair/replacement; broken or missing glass; cracks, rotting, termite infestation or significant rusting present</li>
    </ul>
    `,
    wrapperStyle: {
      class: "grey lighten-3 negative-margins-no-top",
    },
    gridStyle: {
      grid: "col s6",
    },
    fieldStyle: {},
    validations: {},
  },

  door_fair_poor_issue: {
    step: 2,
    target: "door_condition",
    dataConditions: ["fair", "poor"],
    fieldType: "condition_field",
    wrapperStyle: {
      class: "grey lighten-3 negative-margins",
    },
    section: "window",
    value: "",
    label: "If you selected 'fair' or 'poor,' briefly describe the issues.",
    validations: {},
  },
  section_two_complete: {
    step: 2,
    fieldType: "complete_field",
    sectionName: "",
    validations: {},
  },

  /* 	walls_foundations_section_head: {
      step: 3,
      fieldType: "label_field",
      label: 'Walls and Foundations',
      type: "section-head",
      wrapperStyle: {
        class: 'col s12 ',
        style: {
          fontSize: '',
        }
      },
      fieldStyle: {},
      validations: {}
  }, */

  walls_foundations_section_description: {
    step: 3,
    fieldType: "section_desc_field",
    description: /* html */ `
			<div class="sectionX-title">Walls and Foundation</div>
			<p>Examine your home and make enquires
      about its construction to determine any
      known or obvious structural
      deficiencies/weaknesses in the walls and
      foundation. Major structural
      deficiencies/weaknesses in walls or the
      foundation could lead to extreme damage
      during a Category 5 hurricane.</p>
      <div>
      <strong >Resources to help you!</strong>
      </div>

      <ul class="browser-default">
        <li>Photographs illustrating <a href="#" helper-id="F9991">situations that
        may indicate structural problems in
        walls or foundations or geotechnical
        problems,</a> such as settlements</li>

        <li>
        Example photographs of <a href="#" helper-id="F916"> hurricane
        damage resulting from structural
        deficiencies/weaknesses in walls and
        foundations</a>
        </li>
        <li>
        <a href="#" helper-id="F138">Best practices for strong walls and
        foundations</a>
        </li>
        <li>
        Additional illustrations of
        <a href="#" helper-id="F823">proper timber
        framing for walls of wooden houses</a>
        </li>
      </ul>
      `,
    wrapperStyle: {},
    fieldStyle: {},
    validations: {},
  },

  wall_condition: {
    step: 3,
    fieldType: "custom_group_radio_field",
    questionNum: 14,
    showQuestionNum: false,
    label: "1. Based on your review of the resources provided and an inspection of your house, how would you describe the general condition of your walls?",
    placeholder: "",
    helperText: "",
    value: "",
    answer: "isCondition",
    // invalid: true,
    // condition: {
    //     key: 'title',
    //     value: 'mr'
    // },
    description: `
    <ul class="criteria-list">
    <li><b>Good:</b> No structural deficiencies/weaknesses are present.</li>
    <li><b>Fair:</b> Minor structural deficiencies/weaknesses are present. Examples: minor/hairline cracks in limited areas</li>
    <li><b>Poor:</b> Major structural deficiencies/weaknesses are present. Examples: major cracks that penetrate both sides of the wall; concrete walls not reinforced with steel or not filled; timber walls not tied together with timber braces or metal straps</li>
  </ul>`,
    options: [
      {
        text: "Good",
        value: "good",
      },
      {
        text: "Fair",
        value: "fair",
      },
      {
        text: "Poor",
        value: "poor",
      },
    ],
    wrapperStyle: {
      class: "grey lighten-4 negative-margins-no-top",
      style: {
        marginTop: "",
      },
    },
    gridStyle: {
      grid: "col s6",
    },
    fieldStyle: {},
    validations: {},
  },
  wall_fair_poor_issue: {
    step: 3,
    target: "wall_condition",
    fieldType: "condition_field",
    section: "wall",
    dataConditions: ["fair", "poor"],
    value: "",
    wrapperStyle: {
      class: "negative-margins grey lighten-4",
    },
    label: "If you selected 'fair' or 'poor,' briefly describe the issues.",
    validations: {},
  },
  foundation_condition: {
    step: 3,
    fieldType: "custom_group_radio_field",
    questionNum: 15,
    showQuestionNum: false,
    label: "2. Based on your review of the resources provided and an inspection of your house, how would you describe the general condition of your foundation?",
    placeholder: "",
    helperText: "",
    value: "",
    answer: "isCondition",
    section: "wall",
    // invalid: true,
    // condition: {
    //     key: 'title',
    //     value: 'mr'
    // },
    description: /* html */ `
    <ul class="criteria-list">
    <li><b>Good:</b> No structural deficiencies/weaknesses are present. </li>
    <li><b>Fair:</b> Minor structural deficiencies/weaknesses are present. Examples: minor/hairline cracks present</li>
    <li><b>Poor:</b> Major structural deficiencies/weaknesses are present. Examples: major/wide cracks in excess of ½ inch; structure not securely fastened to foundation see example- <a href='#' helper-id='F442'>here</a>).</li>
  </ul>`,
    options: [
      /* 	{
							text: 'Excellent',
							value: 'excellent'
					}, */ {
        text: "Good",
        value: "good",
      },
      {
        text: "Fair",
        value: "fair",
      },
      {
        text: "Poor",
        value: "poor",
      },
    ],
    wrapperStyle: {
      class: "grey lighten-4 negative-margins",
    },
    gridStyle: {
      grid: "col s6",
    },
    fieldStyle: {},
    validations: {},
  },
  foundation_fair_poor_issue: {
    step: 3,
    target: "foundation_condition",
    fieldType: "condition_field",
    dataConditions: ["fair", "poor"],
    section: "wall",
    value: "",
    wrapperStyle: {
      class: "grey lighten-4 negative-margins",
    },
    label: "If you selected 'fair' or 'poor,' briefly describe the issues.",
    validations: {},
  },
  section_three_complete: {
    step: 3,
    fieldType: "complete_field",
    sectionName: "",
    validations: {},
  },
};

export const impactLevelGenerator = (schema, values) => {
  // return 'Minor'

  let rFeaturesImpactLevelBoundary = {
    minor: 10,
    moderate: 6,
    major: 1,
    extreme: 0,
  };

  let totalPoints = 0;

  const getTotalPoints = () => {
    Object.keys(values).map((key) => {
      if (!schema.hasOwnProperty(key)) return null;
      if (schema[key].fieldType === "checkbox_field" || schema[key].fieldType === "custom_group_checkbox_field") {
        if (values[key].length > 0) {
          totalPoints++;
        }
      } else if (schema[key].answer === "isCondition") {
        if (key !== "window_door_condition") {
          if (["excellent", "good"].includes(values[key])) {
            totalPoints += 2;
          } else if (["fair"].includes(values[key])) {
            totalPoints++;
          }
        }
      } else if (schema[key].fieldType === "custom_field") {
        if (values[key]) {
          totalPoints++;
        }
      } else if (schema[key].fieldType === "condition_field" || schema[key].fieldType === "complete_field") {
      } else {
        if (schema[key].answer.includes(values[key])) {
          totalPoints++;
        }
      }
    });
  };

  getTotalPoints();

  // console.log(totalPoints)

  // ROOF FEATURES

  // Get all roof feature question keys
  let roofFeatureQuestions = Object.keys(schema).filter((key) => schema[key].rFeature === "roof");

  // Get all window door feature questions
  let windowDoorFeaturesQuestions = Object.keys(schema).filter((key) => schema[key].rFeature === "window" || schema[key].rFeature === "door");

  // Get roof features answered questions
  let ansRoofFeaturesQuestions = roofFeatureQuestions.filter((key) => !!values[key] && values[key] !== "no");

  const checkBoxValidator = (value) => {
    return value && value.length > 0 ? true : false;
  };

  // Get window door features answered questions
  let ansWindowDoorFeaturesQuestions = windowDoorFeaturesQuestions.filter((key) => {
    if (schema[key].fieldType === "checkbox_field" || schema[key].fieldType === "custom_group_checkbox_field") {
      // console.log(values[key])

      if (checkBoxValidator(values[key])) {
        return key;
      }
    } else {
      if (values[key] === "yes") {
        return key;
      }
    }
  });

  const minorConditionChecker = () => {
    return (values.roof_condition === "excellent" || values.roof_condition === "good") &&
      (values.wall_condition === "excellent" || values.wall_condition === "good") &&
      (values.foundation_condition === "excellent" || values.foundation_condition === "good")
      ? true
      : false;
  };

  const moderateConditionChecker = () => {
    return (values.wall_condition === "excellent" || values.wall_condition === "good") && (values.foundation_condition === "excellent" || values.foundation_condition === "good") ? true : false;
  };
  const majorConditionChecker = () => {
    return values.wall_condition && values.wall_condition !== "poor" && values.foundation_condition && values.foundation_condition !== "poor" ? true : false;
  };
  const extremeConditionChecker = () => {
    return values.wall_condition && values.wall_condition === "poor" && values.foundation_condition && values.foundation_condition === "poor" ? true : false;
  };

  const roofFeaturesModerateChecker = () => {
    if (!ansRoofFeaturesQuestions.includes(roofFeatureQuestions[4]) || !ansRoofFeaturesQuestions.includes(roofFeatureQuestions[5]) || !ansRoofFeaturesQuestions.includes(roofFeatureQuestions[6]))
      return true;

    return false;
  };

  const roofFeaturesMajorChecker = () => {
    if (
      !ansRoofFeaturesQuestions.includes(roofFeatureQuestions[0]) ||
      !ansRoofFeaturesQuestions.includes(roofFeatureQuestions[1]) ||
      !ansRoofFeaturesQuestions.includes(roofFeatureQuestions[2]) ||
      !ansRoofFeaturesQuestions.includes(roofFeatureQuestions[3])
    )
      return true;
    return false;
  };

  const minorRFeaturesChecker = () => {
    let featuresCount = ansRoofFeaturesQuestions.length + ansWindowDoorFeaturesQuestions.length;
    return featuresCount === rFeaturesImpactLevelBoundary.minor ? true : false;
  };

  const moderateRFeaturesChecker = () => {
    let featuresCount = ansRoofFeaturesQuestions.length;

    return featuresCount === rFeaturesImpactLevelBoundary.moderate && roofFeaturesModerateChecker() ? true : false;
  };
  const majorRFeaturesChecker = () => {
    return roofFeaturesMajorChecker() ? true : false;
  };
  const extremeRFeaturesChecker = () => {
    let featuresCount = ansRoofFeaturesQuestions.length + ansWindowDoorFeaturesQuestions.length;

    return featuresCount <= 0 ? true : false;
  };

  // Impact Level Check
  if (minorRFeaturesChecker() && minorConditionChecker()) {
    // MINOR
    // console.log(`minor => ${minorRFeaturesChecker() && minorConditionChecker()}`)
    return "Minor Impact";
  } else if (moderateRFeaturesChecker() && moderateConditionChecker()) {
    // MODERATE
    // console.log(`moderate => ${moderateRFeaturesChecker() && moderateConditionChecker()}`)
    return "Moderate Impact";
  } else if (majorRFeaturesChecker() && majorConditionChecker()) {
    // MAJOR
    // console.log(`major => ${majorRFeaturesChecker() && majorConditionChecker()}`)
    return "Major Impact";
  } else if (extremeRFeaturesChecker() && extremeConditionChecker()) {
    // EXTREME
    // console.log(`extreme => ${extremeRFeaturesChecker() && extremeConditionChecker()}`)
    return "Extreme Impact";
  } else {
    if (totalPoints >= 16) {
      return "Minor Impact";
    } else if (totalPoints < 16 && totalPoints >= 13) {
      return "Moderate Impact";
    } else if (totalPoints < 13 && totalPoints >= 1) {
      return "Major Impact";
    } else {
      return "Extreme Impact";
    }

    // return 'determine with point checker'
  }
  // console.log(schema)
  // console.log(roofFeatureQuestions)
};
